import React, { useState } from 'react'
import CutFieldset from './CutFieldset'
import { Input, Label, Row, Col } from './Bootstrap'
import formDataToObject from "../lib/form-data-to-object"

import CutCalculator from '../models/CutCalculator.jsx'
import Cut from '../models/Cut.jsx'

const Form = (props) => {

  const [calculationResult, setCalculationResult] = useState('')
  const [cuts, setCuts] = useState([])

  const calculateValues = (e) => {
    const form = e.target.form
    const data = formDataToObject(form)
    setCalculationResult(
      new CutCalculator({
        boardLength: data.board_length,
        cuts: data.cuts
      }).output()
    )
  }

  const addCut = (e) => {
    e.preventDefault()
    const lastCut = cuts[cuts.length - 1] || new Cut({quantity: 1,length: 100})
    const defaultLength = lastCut.length
    const defaultQuantity = lastCut.quantity
    const nextCut = new Cut({length: defaultLength, quantity: defaultQuantity})
    const newCuts = cuts.concat([nextCut])
    console.log(newCuts);
    setCuts(newCuts)
  }

  return (
    <form className="form">
      <Row>
        <Col>
            <fieldset>
              <div className="form-group">
                <Label htmlFor="board_length">Board length</Label>
                <Input name="board_length"
                  onChange={calculateValues}
                  defaultValue={2500}>
                </Input>
              </div>
            </fieldset>
            {
              cuts.map((cut, i) => {
                console.log("Cut", cut);
                return (
                  <CutFieldset key={cut.key}
                               index={i}
                               length={cut.length}
                               quantity={cut.quantity} calculateValues={calculateValues} />)
            })}
        </Col>
      </Row>
      <Row>
        <Col>
          <button onClick={addCut} className="btn btn-primary mx-auto d-inline-block">
            Add cut
          </button>
        </Col>
      </Row>
      <Row>
        <Col>
          { calculationResult !== "" ? <h2>Result:</h2> : "" }
          <pre>
            {calculationResult}
          </pre>
        </Col>
      </Row>
    </form>
  )
}

export default Form
